export const jQueryScrollTo = (
  target: string,
  offset = 0,
) => {
  const element = $(target).first();
  const scrollTop = (element.offset()?.top || 0) + offset;

  $('body,html').animate({ scrollTop }, 500, 'swing');
};

export const scrollToElementById = (
  id: string,
  behavior: ScrollBehavior = 'smooth',
  block: ScrollLogicalPosition = 'start'
): void => {
  const target = document.getElementById(id);
  if (target) {
    target.scrollIntoView({ behavior, block });
  }
};

export const scrollToTop = (
  element?: HTMLElement | null,
  offset = 0,
  behavior: ScrollBehavior = 'instant'
) => {
  const top = element
    ? element.getBoundingClientRect().top + window.scrollY - offset
    : 0;
  window.scrollTo({ top, behavior });
};

export const smoothScrollX = (
  element: HTMLElement,
  to: number,
  duration = 300
) => {
  const start = element.scrollLeft;
  const change = to - start;
  const startTime = performance.now();

  let rafId: number;

  const animate = (currentTime: number) => {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);

    const ease = 0.5 * (1 - Math.cos(Math.PI * progress));

    element.scrollLeft = start + change * ease;

    if (progress < 1) {
      rafId = requestAnimationFrame(animate);
    }
  };

  rafId = requestAnimationFrame(animate);

  return () => cancelAnimationFrame(rafId);
};
